import { checkElementInView } from "../../__utils/checkElementInView";

// GLOBAL APP CONTROLLER
const controller = {
    init() {
        checkElementInView('.block-homepage-highlights__icon-wrapper', inView, outOfView, {
            root: null,
            rootMargin: "0px 0px 0px 0px",
            threshold: [1],
        });
    },
    loaded() {},
    resized() {},
    scrolled() {},
    keyDown(e) {},
    scrolled() {},
    keyDown(e) {},
    mouseUp(e) {},
};

const inView = (e) => {
    e.classList.add('in-viewport');
};

const outOfView = (e) => {
};
export default controller;
